/*!
 * roomEvents.js — what the room sends the live console, as window events
 * © 2026 Rob Canning — GPLv3
 *
 * The other end of room.js. Whatever carries the room -- the score's server
 * connection (socket.js) or a relay for Oscilla Live (roomLink.js) -- hands
 * each message here, and the console listens for the events:
 *   oscilla:livecode-buffer   livecode_buffer_update / _list / _clear
 *   oscilla:livecode-follow   livecode_mirror / _mirror_replay / _view / _view_request,
 *                             livecode_mode (the room's: ensemble or jam)
 *   oscilla:livecode-chat     livecode_chat
 *   oscilla:room-timeline     livecode_timeline: the room's beat (roomBeat.js)
 *   oscilla:room-open         the connection is open (again): the console sends
 *                             its buffer and asks for the others'
 *   oscilla:room-closed       left, or refused (roomLink.js): no room now
 */

const EVENTS = {
  livecode_buffer_update: "oscilla:livecode-buffer",
  livecode_buffer_list: "oscilla:livecode-buffer",
  livecode_buffer_clear: "oscilla:livecode-buffer",
  livecode_mirror: "oscilla:livecode-follow",
  livecode_mirror_replay: "oscilla:livecode-follow",
  livecode_view: "oscilla:livecode-follow",
  livecode_view_request: "oscilla:livecode-follow",
  livecode_mode: "oscilla:livecode-follow",
  livecode_chat: "oscilla:livecode-chat",
  livecode_timeline: "oscilla:room-timeline",
};

/** A message from the room: true when it was the console's (and is passed on). */
export function deliverRoomMessage(data) {
  const type = EVENTS[data?.type];
  if (!type) return false;
  window.dispatchEvent(new CustomEvent(type, { detail: data }));
  return true;
}

/** The room's connection is open, first time or again. */
export function roomOpened() {
  window.dispatchEvent(new Event("oscilla:room-open"));
}
